// src/components/About.jsx
import FadeIn from './FadeIn';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="section-header">
        <h2>à propos</h2>
        <span className="section-line"></span>
      </div>
      <div className="about-content">
        <p>Hello !</p>

        <p>
          Je suis <strong>Nathalie Liu</strong>, ingénieure logicielle. <br />
          J'aime construire des choses, et concevoir des interfaces en fait partie.
        </p>

        <p>
          Trois ans de développement m'ont appris comment un produit tient debout. <br />
          Le design me permet de décider comment on le vit. <br />
          <strong>Je code, je dessine, je conçois.</strong>
        </p>

        <p>
          Mon premier vrai contact avec le design, c'était la refonte d'un centre
          d'aide client : comprendre pourquoi les gens n'y trouvaient pas leurs
          réponses, et reconstruire le parcours.
        </p>

        <p>
          Je rejoins le <strong>Mastère Product Design UX/UI à l'IIM</strong> en octobre 2026.
        </p>

        <p>
          <strong>Design</strong> : Figma, Procreate <br />
          <strong>Code</strong> : HTML/CSS/JS, React, PHP/Symfony, Python <br />
          <strong>Creative coding</strong> : p5.js, Three.js
        </p>

        <p>
          Disponible en <strong>alternance UX/UI</strong> à partir de septembre 2026.
        </p>
      </div>
    </section>
  );
}